import { Inject, Injectable, Injector } from '@angular/core';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';

import { Utilities_OperationService } from './Utilities.operation.service';
import { Totes_OperationService } from './Totes.operation.service';


@Injectable({ providedIn: 'root' })
export class ProgrammableLogicController_OperationService {

  constructor(
    private injector: Injector,
    private $utils: UtilsService,
  ) {
    this.Utilities = this.injector.get(Utilities_OperationService);
    this.Totes = this.injector.get(Totes_OperationService);
  }

    public Utilities: Utilities_OperationService;
    public Totes: Totes_OperationService;
  public ProgrammableLogicController: ProgrammableLogicController_OperationService = this;


  private isAuthorized(operationName: string): Promise<boolean> {
    return this.$utils.http.post(`${environment.backendUrl}api/ProgrammableLogicController/operations/${operationName}/isauthorized`, null);
  }
}
